var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEdit1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.11761 8.82367H5.41174C4.50689 8.82367 3.6391 9.18312 2.99928 9.82295C2.35945 10.4628 2 11.3306 2 12.2354V27.5883C2 28.4931 2.35945 29.3609 2.99928 30.0007C3.6391 30.6405 4.50689 31 5.41174 31H20.7646C21.6694 31 22.5372 30.6405 23.1771 30.0007C23.8169 29.3609 24.1763 28.4931 24.1763 27.5883V25.8824",
    stroke: "#fff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4704 5.41193L27.588 10.5295M29.9506 8.11573C30.6225 7.44388 30.9999 6.53265 30.9999 5.58251C30.9999 4.63237 30.6225 3.72115 29.9506 3.04929C29.2788 2.37744 28.3676 2 27.4174 2C26.4673 2 25.5561 2.37744 24.8842 3.04929L10.5293 17.353V22.4706H15.6469L29.9506 8.11573Z",
    stroke: "#ffffff",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEdit1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit1.e5432fdd3d9f024d152c0ae30789d301.svg";